import React from 'react';
import { useTranslation } from 'react-i18next';
import { Transition } from '@headlessui/react';

import ReactDOM from 'react-dom';
import { useMobxStores } from '@stores/store';
import { observer } from 'mobx-react';
import NoSSR from '@molecules/NoSSR';
import SimpleYoutube from '@molecules/slider/SimpleYoutube';
import Layer from '@molecules/modal/Layer';
import { useLocation, useNavigate } from 'react-router-dom';
import ShareBtn from '@atoms/btn/ShareBtn';

const Portal = ({ children }) => {
  return ReactDOM.createPortal(children, document.querySelector('body'));
};

const CommonMediaDialog = ({ src, type, title }) => {
  const { i18n } = useTranslation();
  const { settingStore } = useMobxStores();

  const navigate = useNavigate();
  const location = useLocation();
  const onClose = () => {
    settingStore.setCommonDialogState(false);
    settingStore.setCommonDialogSrcState('');
  };

  return (
    <NoSSR>
      <div className="relative z-20 text-left  w-full">
        <Transition
          show={settingStore.commonDialogState}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        ></Transition>
        <Portal>
          <Layer
            isOpen={settingStore.commonDialogState}
            onClose={() => onClose()}
          >
            <div className="shadow-xl items-center text-center">
              <p className=" pb-1 pr-10 opacity-95 text-left text-white"></p>
              {type == 'image' && (
                <div className=" bg-black">
                  <img src={src} alt={title} className="m-auto" />
                </div>
              )}
              {type == 'video' && (
                <SimpleYoutube
                  videoId={settingStore.commonDialogSrcState}
                  setOnPlay={true}
                  onPlay={true}
                />
              )}
            </div>
            <ShareBtn src={src} type={type} title={title} />
          </Layer>
        </Portal>
      </div>
    </NoSSR>
  );
};

export default observer(CommonMediaDialog);
